module.exports = __webpack_public_path__ + "static/media/Horiz Logo.951f982a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/Horiz Logo.svg
// module id = 1006
// module chunks = 388